// First-name extraction for greetings — single rule for the whole app.
// The only accepted source is the name the account itself set:
//   Supabase auth metadata full_name → its first word.
// Nothing else. No hardcoded placeholder, and deliberately no email
// local-part fallback: "ערב טוב, nagardavid88" is not the user's name, so
// when no name exists this returns "" and the caller greets without a name.
export function getFirstName(session) {
  const metaName = session?.user?.user_metadata?.full_name;
  if (typeof metaName === "string" && metaName.trim()) {
    return metaName.trim().split(/\s+/)[0];
  }
  return "";
}

// Header greeting line. Falls back to the bare greeting word when there is
// no name to show, instead of leaving a dangling comma.
export function greetingWithName(name, lang = "he") {
  const word = lang === "en" ? "Hello" : "שלום";
  return name ? `${word}, ${name}` : word;
}
